var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        title: _vm.$t("message.languageSelection"),
        "show-footer": false,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column" },
        [
          _c(
            "a-select",
            {
              staticClass: "my-2",
              attrs: {
                "show-search": "",
                "option-filter-prop": "children",
                "filter-option": _vm.filterOption,
                autofocus: true,
              },
              model: {
                value: _vm.selectedLang,
                callback: function ($$v) {
                  _vm.selectedLang = $$v
                },
                expression: "selectedLang",
              },
            },
            _vm._l(_vm.languages, function (lang) {
              return _c(
                "a-select-option",
                { key: lang.code, attrs: { value: lang.code } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(lang.originalName) +
                      " - " +
                      _vm._s(lang.label) +
                      " / " +
                      _vm._s(lang.code) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "success" },
              on: { click: _vm.selectLang },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("message.save")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }